export const colWidthBreakpoints = {
  s: 3 / 6,
  m: 6 / 12,
  l: 4 / 12,
  xl: 3 / 12,
};

export const perPageBreakpoints = { s: 1, m: 2, l: 3, xl: 4 };
